import React, { useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { SelectLicense, Input, useForm, FormProvider } from 'common/Form'
import { useTranslation } from 'react-i18next'

export default function ModalSelfUseLicense({
	show,
	onHide,
	licenses,
	onActivate,
	onActivateCode,
	loading,
}) {
	const { t } = useTranslation('account')
	const [mode, setMode] = useState('select')
	const methods = useForm()
	const { handleSubmit, watch, reset } = methods
	const selectedLicense = watch('license')
	const code = watch('code')

	const onSubmit = handleSubmit(({ license, code }) => {
		if (mode === 'code') {
			onActivateCode && onActivateCode(code.trim())
		} else {
			onActivate(license)
		}
	})

	const handleClose = () => {
		reset()
		setMode('select')
		onHide()
	}

	const switchToCode = () => {
		reset()
		setMode('code')
	}

	const switchToSelect = () => {
		reset()
		setMode('select')
	}

	const isCodeMode = mode === 'code'
	const canSubmit = isCodeMode
		? !!(code && code.trim())
		: !!selectedLicense

	return (
		<Modal show={show} onHide={handleClose} centered>
			<Modal.Header closeButton>
				<Modal.Title>{t('license_manager.modal_self_use.title')}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<FormProvider {...methods}>
					{isCodeMode ? (
						<>
							<p className="text-muted">
								{t('license_manager.modal_self_use.code_description')}
							</p>
							<Input
								name="code"
								placeholder={t('license_manager.modal_self_use.code_placeholder')}
								rules={{ required: t('license_manager.modal_self_use.code_rule') }}
							/>
							<button
								type="button"
								className="btn btn-link p-0"
								onClick={switchToSelect}
							>
								{t('license_manager.modal_self_use.back_to_select')}
							</button>
						</>
					) : (
						<>
							<p className="text-muted">
								{t('license_manager.modal_self_use.description')}
							</p>
							<SelectLicense
								name="license"
								licenses={licenses}
								placeholder={t('license_manager.modal_self_use.placeholder')}
								rules={{ required: t('license_manager.modal_self_use.rule') }}
							/>
							<button
								type="button"
								className="btn btn-link p-0"
								onClick={switchToCode}
							>
								{t('license_manager.modal_self_use.use_code_link')}
							</button>
						</>
					)}
				</FormProvider>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="dark" onClick={handleClose}>
					{t('license_manager.cancel')}
				</Button>
				<Button
					variant="primary"
					onClick={onSubmit}
					disabled={loading || !canSubmit}
				>
					{isCodeMode
						? t('license_manager.modal_self_use.code_activate')
						: t('license_manager.modal_self_use.activate')}
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
